import React from "react";

class SwitchField extends React.Component{
    render(){
        const that = this
        return (
            <div class="js-form-field-switch-wrapper">
                <input
                    type="checkbox"
                    name={this.props.name}
                    id={this.props.id}
                    required={this.props.required} 
                    />

                <div class="js-switch">
                    <div class="js-switch__track">
                        <div class="js-switch__thumb"></div>
                    </div>
                </div>

                <label for={this.props.id} class="form__label">
                    {this.props.label}
                    {this.props.required && (
                        <span class="chart-red">*</span>
                    )}
                </label>
            </div>
        )
    }
}

export default SwitchField